module.exports = __webpack_public_path__ + "img/PDAC1_TMKI67.0544b96b.png";